<template>
    <div class="md:relative inline-block select-none">
        <div @click.prevent="showContactGroupSelectionPopover = true" class="cursor-pointer">
            <div v-if="mutableContactGroup && mutableContactGroup.secondary_identifier_id"
                 class="text-center text-sm font-medium text-indigo-600">
                <span>{{ mutableContactGroup.secondary_identifier_id }}</span>

                <span class="text-gray-400 font-normal" v-if="primaryContact">
                    - {{ primaryContact.full_name }}
                </span>

                <badge v-if="mutableContactGroup.archived_at" class="text-yellow-600 bg-yellow-100">{{mutableContactGroup.group_type | titlecase}} Archived</badge>
            </div>

            <div v-else>
                <div class="text-center text-sm font-medium text-indigo-600">No Associated Lease</div>
            </div>
        </div>

        <div v-if="showContactGroupSelectionPopover" v-click-outside="hidePopover"
             class="absolute mt-6 z-40 top-0 left-0 p-4 rounded bg-white shadow-lg"
             style="min-height: fit-content !important;">
            <div style="width: 300px">
                <remote-select
                    v-model="mutableContactGroup"
                    @focus="fetchContactGroups"
                    input-classes="text-xs cursor-pointer hover:border-indigo-600"
                    :remote-method="fetchContactGroups"
                    :loading="loading"
                    :data="contactGroups"
                    item-label="compiled_label"
                    selected-item-label-classes="text-xs"
                    placeholder="Select Lease">
                    <template slot-scope="props">
                        <div class="text-sm font-medium text-gray-900 py-3 flex flex-col gap-2">
                            <div class="font-semibold flex flex-col justify-between leading-snug">
                                <div>
                                    {{ props.item.start_date | date }}
                                    {{ props.item.end_date ? "to " + $options.filters.date(props.item.end_date) : "to no end date" }}
                                </div>
                                <div class="flex items-center gap-2">
                                    <div class="text-indigo-600">{{ props.item.secondary_identifier_id }}</div>
                                    <badge v-if="props.item.archived_at" class="text-yellow-600 bg-yellow-100" text-size="text-sm">Archived</badge>
                                </div>
                            </div>

                            <div v-if="props.item.contacts && props.item.contacts.length > 0">
                                <ul class="text-gray-400 font-normal leading-snug">
                                    <li v-for="contact in props.item.contacts" class="flex gap-2 items-center">
                                        <icon-user class="w-4 h-4" :filled="contact.pivot.primary"></icon-user>
                                        <span class="text-sm">{{ contact.full_name }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </template>
                </remote-select>

                <div class="mt-2 flex justify-end">
                    <button class="text-indigo-600 text-sm outline-none hover:text-indigo-700 transition duration-300"
                            @click.prevent="updateContactGroupForModel">
                        Update
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ChangeContactGroup",

    props: {
        id: {
            type: String,
            required: false,
            default: () => (Math.random() * 99999).toFixed(0)
        },
        groupType: {
            type: String,
            required: true
        },
        modelType: {
            type: String,
            required: true
        },
        modelId: {
            type: Number,
            required: true
        },
        contactGroup: {
            type: Object,
            required: false,
            default: null
        },
        contactGroupsUrl: {
            type: String,
            required: true,
        },
    },

    data () {
        return {
            mutableContactGroup: null,
            showContactGroupSelectionPopover: false,
            loading: false,
            contactGroups: []
        };
    },

    computed: {
        primaryContact () {
            if (!this.contactGroup || this.contactGroup?.contacts?.length === 0) {
                return null;
            }

            let index = this.contactGroup.contacts.findIndex((c) => c.pivot.primary == true);
            return index >= 0 ? this.contactGroup.contacts[index] : null;
        },
    },

    watch: {
        contactGroup (value) {
            this.mutableContactGroup = value;
        },
    },

    methods: {
        hidePopover () {
            this.showContactGroupSelectionPopover = false;
        },

        fetchContactGroups: _.debounce(function (value) {
            this.loading = true;

            axios.get(this.contactGroupsUrl, {
                params: {
                    with_archived: true
                }
            })
            .then(response => {
                this.loading = false;
                this.contactGroups = response.data;
            })
            .catch(errors => {
                this.loading = false;
                toastr.error(errors.message);
            });
        }, 300),

        updateContactGroupForModel () {
            let requestForm = new AppForm({
                remove_contact_group: this.mutableContactGroup === null,
                group_type: this.groupType,
                class: this.modelType,
                model_id: this.modelId,
                contact_group_id: this.mutableContactGroup ? this.mutableContactGroup.id : this.contactGroup.id
            });

            App.post(`/contact-groups/change-selection`, requestForm)
            .then((response) => {
                toastr.success(response.message);
                this.$emit("contact-group-selected", this.mutableContactGroup);
                this.hidePopover();
                Bus.$emit("new-contacts-available");
            })
            .catch((error) => {
                toastr.success("Failed to update " + this.mutableContactGroup.group_type + ": " + error);
            });
        },
    },
};
</script>
